/**
 * Add domNodes around a text in a node
 * @param {HTMLElement} node  the node to modify
 * @param {string|null} separator   an optional separator to determinate which text has to be sliced (by default, all the text)
 * @param {string} before     text to add before the node's text
 * @param {string} after      text to add after the node's text
 */
export function insertNodeAround(node, separator = null, before = '<strong>', after = '</strong>') {
   let text = node.innerText
   let indexSlash = separator ? text.indexOf(separator) : text.length
   let surroundedText = text.substring(0, indexSlash).trim()
   let afterSurroundedText = text.substring(indexSlash + (separator ? separator.length : 0)).trim()
   node.innerHTML = `${before}${surroundedText}${after}${separator}${afterSurroundedText}`
}

export function isEmptyArray(arr) {
   return false === Array.isArray(arr) || 0 === arr.length
}

export function isEmptyObject(obj) {
   for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
         return false
      }
   }
   return JSON.stringify(obj) === JSON.stringify({})
}

export function isObject(obj) {
   return null !== obj && 'object' === typeof obj
}

export const proxymedia = (url = '', querystring = '') => {
   // si l'url contient un ? on retourne juste l'url sinon, on ajoute le ? et le querystring
   if (url.indexOf('?') !== -1 || querystring === '') {
      return url
   } else {
      return url + '?' + querystring
   }
}

export const Slugify = (str) => {
   str = str.replace(/^\s+|\s+$/g, '')
   // Make the string lowercase
   str = str.toLowerCase()
   // Remove accents, swap ñ for n, etc
   var from = 'ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;'
   var to = 'AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------'
   for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
   }
   // Remove invalid chars
   str = str
      .replace(/[^a-z0-9 -]/g, '')
      // Collapse whitespace and replace by -
      .replace(/\s+/g, '-')
      // Collapse dashes
      .replace(/-+/g, '-')
   return str
}

/**
 * Va lire les classes css du body pour définir
 * si on est sur mobile device
 * @returns {boolean}
 */
export const isMobile = () => {
   return document.body.classList.contains('is-mobile') ? true : false
}

/**
 * Va lire les classes css du body pour définir
 * si on est sur desktop device
 * @returns {boolean}
 */
export const isDesktop = () => {
   return document.body.classList.contains('is-mobile') ? false : true
}

/**
 * --------------------------------------------------------------------------
 * Uppercase first character in string
 * --------------------------------------------------------------------------
 */
export function capitalizeFirstLetter(string) {
   return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * --------------------------------------------------------------------------
 * Uppercase first character in string
 * --------------------------------------------------------------------------
 */
export const isForcedProd = () => {
   let isForcedProd = false
   if (document.cookie.search('isForcedProd') !== -1) {
      isForcedProd = true
   }
   return isForcedProd
}

/**
 * Parse nested tags bbcode and replace them by html tags
 * @param str string to be parsed
 * @param {boolean} emptyTags if true, the tags will be removed and replaced by a simple space
 * @returns {*}
 */
function replaceNestedTags(str, emptyTags = false) {
   const replaceValue = emptyTags ? '$2' : '<span class="$1">$2</span>'
   let newStr = str.replace(/\[(color|highlight|bold|price|prix|mirror)\]((?:[^[]|\[(?!\/\1\]))*)\[\/\1\]/gm, replaceValue)
   if (str === newStr) {
      return newStr
   } else {
      return replaceNestedTags(newStr)
   }
}

/**
 * Parse simple tags bbcode and replace them by html tags
 * @param str string to be parsed
 * @param {boolean} emptyTags if true, the tags will be removed and replaced by a simple space
 * @returns {*}
 */
export const tagParser = (str, emptyTags = false) => {
   if (typeof str === 'string') {
      str = replaceNestedTags(str, emptyTags)
      const replacements = [
         { searchValue: /\[icon=(info|device-smart-phone|hands-free)\]/gm, replaceValue: '<span class="icon icon-$1"></span>' },
         { searchValue: /\[retour\]/gm, replaceValue: '<br>' },
         { searchValue: /\[espace\]/gm, replaceValue: '&nbsp;' },
         { searchValue: /\[on\]/gm, replaceValue: '<span class="orange-on">on</span>' },
         { searchValue: /\↓/gm, replaceValue: '<span aria-hidden="true">↓</span><span class="sr-only">débit descendant</span>' },
         { searchValue: /\↑/gm, replaceValue: '<span aria-hidden="true">↑</span><span class="sr-only">débit montant</span>' },
      ]
      replacements.forEach((replacement) => {
         str = str.replace(replacement.searchValue, emptyTags ? ' ' : replacement.replaceValue)
      })
   }
   return str
}

export const linkParser = (str) => {
   if (typeof str === 'string') {
      // Crée des liens cliquable si on detecte une URL
      str = str.replaceAll(/(http:\/\/|https:\/\/)/gm, '')
      str = str.replaceAll(
         /[a-zA-Z0-9-._]+(\.fr|\.com|\.org|\.net|\.eu|\.paris|\.edu|\.biz|\.info)([/?][a-zA-Z0-9-_~!*'();\.:@&=+$,/?#[\]%]+)?/gm,
         '<a href="https://$&" target="_blank" tabindex="-1">$&</a>'
      )
      return str
   }
}

// @todo US 6035 remove replaceFilter after all the editorial contents are updated
export const replaceFilter = (string) => {
   return string.replaceAll('__SPACE__', '&nbsp;').replaceAll('__NL__', '<br>')
}

// @todo US 6035 remove replaceCleaner after all the editorial contents are updated
export const replaceCleaner = (string) => {
   return string.replaceAll('__SPACE__', ' ').replaceAll('__NL__', ' ')
}

export const isTouchDevice = () => {
   return 'ontouchstart' in window || navigator.msMaxTouchPoints > 0
}

export const isMin736px = () => {
   return window.matchMedia('(min-width: 736px)').matches
}

// Calcul et expose la largeur de la scrollbar
let isSseEndOfTransmissionListenerAdded = false
export const updateCSSVarScrollbarWidth = () => {
   if (!isSseEndOfTransmissionListenerAdded) {
      document.addEventListener('sseEndOfTransmition', () => {
         const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
         document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)
      })
      isSseEndOfTransmissionListenerAdded = true
   }
}

export const addScript = (type = '', content = '', src = '', callback, defer = false, testid = '') => {
   let tag = document.createElement('script')
   src !== '' ? (tag.src = src) : ''
   type !== '' ? (tag.type = type) : ''
   content !== '' ? (tag.textContent = content) : ''
   typeof callback === 'function' ? (tag.onload = callback) : ''
   defer === true ? (tag.defer = true) : ''
   testid != '' ? (tag.dataset.testid = testid) : ''
   document.head.appendChild(tag)
}
